// src/theme/colors.js
export const colors = {
  primary: "#136F63",
  secondary: "#1E40AF",
  accent: "#38BDF8",

  background: "#F9FAFB",
  surface: "#FFFFFF",

  textPrimary: "#111827",
  textSecondary: "#6B7280",
};
